// extracted by mini-css-extract-plugin
module.exports = {"collections-handover-modal-wrapper":"collections-handover-modal-wrapper--274_3","collectionsHandoverModalWrapper":"collections-handover-modal-wrapper--274_3"};